import { configureStore } from "@reduxjs/toolkit";
import authUserReducer from "../components/Auth/userSlice";
import modeReducer from "../components/Theme/modeSlice";
import walletReducer from "../components/Wallet/walletSlice";
import notificationReducer from "../components/Notifications/notificationSlice";
import redirectReducer from "../components/Auth/historySlice";
import plansReducer from "../request/Plans/planSlice";
import authReducer from "../request/Auth/authSlice";
import referralReducer from "../request/Referrals/referalSlice";
// import unitAnalysisReducer from "../components/Analysis/analysisSlice";
// import chartsReducer from "../components/Analysis/chartsSlice";
import coinReducer from "../request/CoinRates/coinSlice";
import historyReducer from "../request/Analysis/hitorySlice";
import earningRateReducer from "../request/Earning/rateSlice";
import currentPaiReducer from "../components/Trader/tradingSlice";
import tradersReducer from "../request/Traders/tradersSlice";
import messageReducer from "../components/Message/messageSlice";
import p2pPartnerReducer from "../request/P2PPartner/p2pPartnerSlice";
import p2pReducer from "../request/P2P/p2pSlice";
import countriesReducer from "../request/Countries/countriesSlice";
import userReducer from "../request/User/userSlice";

export const store = configureStore({
    reducer: {
        user: authUserReducer,
        userData: userReducer,
        messages: messageReducer,
        mode: modeReducer,
        wallet: walletReducer,
        notifications: notificationReducer,
        redirect: redirectReducer,
        plans: plansReducer,
        auth: authReducer,
        referrals: referralReducer,
        // unitsAnalysis: unitAnalysisReducer,
        // chartsAnalysis: chartsReducer,
        coins: coinReducer,
        history: historyReducer,
        earning_rates: earningRateReducer,
        currentPair: currentPaiReducer,
        traders: tradersReducer,
        p2pPartner: p2pPartnerReducer,
        p2p: p2pReducer,
        countries: countriesReducer

    }
})